import React, { FC } from 'react';
import cx from 'classnames';

import styles from './wrapper.module.scss';

interface IProps {
  className?: string;
  role?: string;
}

const Wrapper: FC<IProps> = ({
  children,
  className,
  role,
}) => (
  <div
    className={cx(styles.wrapper, className)}
    role={role}
  >
    {children}
  </div>
);

export default Wrapper;
